export const BlogData = [
  {
    title: "Firebase Deployment",
    postLogo: "https://miro.medium.com/max/1400/1*SFFbo8lkNxVQcmLrLDVRNw.png",
    postLink: "https://ozerozturkk.medium.com/firebase-deployment-9b4cfad44021",
    content:
      "These steps, which I followed sequentially, enabled me to successfully deploy my project on Firebase...",
  },
  {
    title: "Contributing to the Open-Source",
    postLogo: "https://miro.medium.com/max/1400/0*DnRcvzCesZ-sy3wT",
    postLink:
      "https://ozerozturkk.medium.com/contributing-to-the-open-source-99b557c2375",
    content:
      "How to contribute to the open-source or how can you give a hand to the community? These questions were constantly running through my head a while ago...",
  },
  {
    title: "Live Server Extension of Visual Studio Code",
    postLogo: "https://miro.medium.com/max/1400/1*NH4f-bCCBj34n_CWORXErg.png",
    postLink:
      "https://ozerozturkk.medium.com/live-server-extension-of-visual-studio-code-4affb9651562",
    content:
      "Live server is almost one of the most actively used Vscode extensions. You can view the project you have done on Vscode instantly in the browser...",
  },
  {
    title: "Thinking Outside of the Box",
    postLogo:
      "https://ozerozturkk.files.wordpress.com/2021/03/outside-box.jpg?w=1024",
    postLink:
      "https://ozerozturkk.wordpress.com/2021/03/21/thinking-outside-of-the-box/",
    content:
      "The term “Thinking Outside of the Box” narrate the hidden solutions of the events that we all encounter at least once in our lives...",
  },
  {
    title: "Up and Down",
    postLogo: "https://miro.medium.com/max/4800/0*t0ARoC8IVMSm_Tyb",
    postLink: "https://ozerozturkk.medium.com/up-and-down-36da919aaa6c",
    content:
      "On the other hand, there are so many factors around us that distract us, try to attract our attention, and want to take our time. These are as close as...",
  },
  {
    title: "Changing the Environment with GDG DevFest",
    postLogo: "https://miro.medium.com/max/700/1*LzXxO6I8oJpl841Zv4TIPg.png",
    postLink:
      "https://medium.com/@ozerozturkk/changing-the-environment-with-gdg-devfest-7197f10ebd9f",
    content:
      "I found myself in a community of incredibly energetic, lively, positive, and kind people. And it happened in just one day...",
  },
];
